<template>
  <v-container  fluid style="margin: 20px; padding: 10px; width: 100%">
    <v-data-table :items="tableTodo" hide-default-header :items-per-page="5">
      <template v-slot:header>
        <thead>
          <tr class="light-blue1-custom">
            <th colspan="1" class="text-center border-custom">
              <h3><span>ภาพรวม(คัน)</span></h3>
            </th>
            <th colspan="3" class="text-center border-custom">
              <h3>
                <span> รถในระบบทั้งหมด ({{ header.total }})</span>
              </h3>
            </th>
            <th colspan="3" class="text-center border-custom">
              <h3>
                <span>รถเข้าประจำวัน ({{ header.daily }})</span>
              </h3>
            </th>
            <th colspan="3" class="text-center border-custom">
              <h3>
                <span> รถเสร็จประจำวัน ({{ header.finish }})</span>
              </h3>
            </th>
            <th colspan="3" class="text-center border-custom">
              <h3>
                <span>รถล่าช้าทั้งหมด ({{ header.late }})</span>
              </h3>
            </th>
          </tr>

          <tr class="light-blue2-custom">
            <th width="8%" rowspan="2" class="yellow-custom text-center">
              <h3>
                <span>รถนัดหมาย <br />({{ countAppoint }})</span>
              </h3>
            </th>
            <th colspan="10" class="text-center" style="color: white;">
              <h3><span>รถที่กำลังทำอยู่</span></h3>
            </th>
            <th width="8%" rowspan="2" class="yellow text-center">
              <h3>
                <span>รถรอส่งมอบ <br />({{ countDelivery }})</span>
              </h3>
            </th>
            <th width="8%" rowspan="2" class="green-custom text-center">
              <h3>
                <span>รถส่งมอบแล้ว <br />({{ countDeliveried }})</span>
              </h3>
            </th>
          </tr>
          <tr>
            <th>
              <h3 class="text-center">
                รถเลื่อนนัด <br />({{ countPostpone }})
              </h3>
            </th>
            <th>
              <h3 class="text-center">
                รออะไหล่ <br />({{ countWaitingParts }})
              </h3>
            </th>
            <th>
              <h3 class="text-center">เคาะ <br />({{ countKnock }})</h3>
            </th>
            <th>
              <h3 class="text-center">
                เตรียมพื้น <br />({{ countPrepareGround }})
              </h3>
            </th>
            <th>
              <h3 class="text-center">ผสมสี <br />({{ countMixColor }})</h3>
            </th>
            <th>
              <h3 class="text-center">พ่นสี <br />({{ countSprayPaint }})</h3>
            </th>
            <th>
              <h3 class="text-center">ประกอบ <br />({{ countAssemble }})</h3>
            </th>
            <th>
              <h3 class="text-center">ขัดสี <br />({{ countWax }})</h3>
            </th>
            <th>
              <h3 class="text-center">ล้าง/เก็บงาน <br />({{ countClean }})</h3>
            </th>
            <th>
              <h3 class="text-center">ตรวจสอบ <br />({{ countCheck }})</h3>
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:body="{ items }">
        <tbody name="list" v-if="items.length > 0">
          <tr v-for="item in items" :key="item.jobId" class="item-row">
            <td width="9%" class="yellow-custom-2">
              <div class="text-center">
                <v-chip
                  @click="clickOpenDialog(item.appoint.jobId)"
                  v-if="item.appoint"
                  :color="getColor(item.appoint.jobSize)"
                  dark
                  >{{ item.appoint.licenseNo }}
                  <v-icon class="mx-1" small v-if="item.appoint.carPresent == false">
                    mdi-cancel
                  </v-icon>
                  <v-icon class="mx-1" small v-if="item.appoint.late == true">
                    mdi-clock
                  </v-icon>
                </v-chip>
              </div>
            </td>
            <td>
              <div class="text-center">
                <v-chip
                  @click="clickOpenDialog(item.postpone.jobId)"
                  v-if="item.postpone != null"
                  :color="getColor(item.postpone.jobSize)"
                  dark
                  >{{ item.postpone.licenseNo }}
                  <v-icon class="mx-1" small color="red" v-if="item.postpone.carPresent == false">
                    mdi-cancel
                  </v-icon>
                  <v-icon class="mx-1" small v-if="item.postpone.late == true">
                    mdi-clock
                  </v-icon>
                </v-chip>
              </div>
            </td>
            <td>
              <div class="text-center">
                <v-chip
                  @click="clickOpenDialog(item.waitingParts.jobId)"
                  v-if="item.waitingParts"
                  :color="getColor(item.waitingParts.jobSize)"
                  dark
                  >{{ item.waitingParts.licenseNo }}
                  <v-icon class="mx-1"
                    small
                    color="red"
                    v-if="item.waitingParts.carPresent == false"
                  >
                    mdi-cancel
                  </v-icon>
                    <v-icon class="mx-1" small v-if="item.waitingParts.late == true">
                    mdi-clock
                  </v-icon>
                  </v-chip
                >
              </div>
            </td>
            <td>
              <div class="text-center">
                <v-chip
                  @click="clickOpenDialog(item.knock.jobId)"
                  v-if="item.knock != null"
                  :color="getColor(item.knock.jobSize)"
                  dark
                  >{{ item.knock.licenseNo }}
                  <v-icon class="mx-1" small color="red" v-if="item.knock.carPresent == false">
                    mdi-cancel
                  </v-icon>
                  <v-icon small  v-if="item.knock.revise == true">
                    mdi-puzzle-edit
                  </v-icon>
                  <v-icon class="mx-1" small v-if="item.knock.late == true">
                    mdi-clock
                  </v-icon>
                </v-chip>
              </div>
            </td>
            <td>
              <div class="text-center">
                <v-chip
                  @click="clickOpenDialog(item.prepareGround.jobId)"
                  v-if="item.prepareGround"
                  :color="getColor(item.prepareGround.jobSize)"
                  dark
                  >{{ item.prepareGround.licenseNo }}
                  <v-icon
                    class="mx-1"
                    color="red"
                    small
                    v-if="item.prepareGround.carPresent == false"
                  >
                    mdi-cancel
                  </v-icon>
                  <v-icon small  v-if="item.prepareGround.revise == true">
                    mdi-puzzle-edit
                  </v-icon>
                  <v-icon class="mx-1" small v-if="item.prepareGround.late == true">
                    mdi-clock
                  </v-icon>
                  </v-chip
                >
              </div>
            </td>
            <td>
              <div class="text-center">
                <v-chip
                  @click="clickOpenDialog(item.mixColor.jobId)"
                  v-if="item.mixColor"
                  :color="getColor(item.mixColor.jobSize)"
                  dark
                  
                  >{{ item.mixColor.licenseNo }}
                  <v-icon class="mx-1" color="red" small v-if="item.mixColor.carPresent == false">
                    mdi-cancel
                  </v-icon>
                  <v-icon small  v-if="item.mixColor.revise == true">
                    mdi-puzzle-edit
                  </v-icon>
                  <v-icon class="mx-1" small v-if="item.mixColor.late == true">
                    mdi-clock
                  </v-icon>
                  </v-chip>
              </div>
            </td>
            <td>
              <div class="text-center">
                <v-chip
                  @click="clickOpenDialog(item.sprayPaint.jobId)"
                  v-if="item.sprayPaint"
                  :color="getColor(item.sprayPaint.jobSize)"
                  dark
                >
                  {{ item.sprayPaint.licenseNo }}
                  <v-icon class="mx-1" color="red" small v-if="item.sprayPaint.carPresent == false">
                    mdi-cancel
                  </v-icon>
                  <v-icon small  v-if="item.sprayPaint.revise == true">
                    mdi-puzzle-edit
                  </v-icon>
                  <v-icon class="mx-1" small v-if="item.sprayPaint.late == true">
                    mdi-clock
                  </v-icon>
                </v-chip>
              </div>
            </td>
            <td>
              <div class="text-center">
                <v-chip
                  @click="clickOpenDialog(item.assemble.jobId)"
                  v-if="item.assemble"
                  :color="getColor(item.assemble.jobSize)"
                  dark
                  >{{ item.assemble.licenseNo }}
                  <v-icon class="mx-1" color="red" small v-if="item.assemble.carPresent == false">
                    mdi-cancel
                  </v-icon>
                  <v-icon small  v-if="item.assemble.revise == true">
                    mdi-puzzle-edit
                  </v-icon>
                   <v-icon class="mx-1" small v-if="item.assemble.late == true">
                    mdi-clock
                  </v-icon>
                </v-chip>
              </div>
            </td>
            <td>
              <div class="text-center">
                <v-chip
                  @click="clickOpenDialog(item.wax.jobId)"
                  v-if="item.wax"
                  :color="getColor(item.wax.jobSize)"
                  dark
                  >{{ item.wax.licenseNo }}
                  <v-icon class="mx-1" color="red" small v-if="item.wax.carPresent == false">
                    mdi-cancel
                  </v-icon>
                  <v-icon small  v-if="item.wax.revise == true">
                    mdi-puzzle-edit
                  </v-icon>
                  <v-icon class="mx-1" small v-if="item.wax.late == true">
                    mdi-clock
                  </v-icon>
                </v-chip>
              </div>
            </td>
            <td>
              <div class="text-center">
                <v-chip
                  @click="clickOpenDialog(item.clean.jobId)"
                  v-if="item.clean"
                  :color="getColor(item.clean.jobSize)"
                  dark
                  >{{ item.clean.licenseNo }}
                  <v-icon class="mx-1" color="red" small v-if="item.clean.carPresent == false">
                    mdi-cancel
                  </v-icon>
                  <v-icon small  v-if="item.clean.revise == true">
                    mdi-puzzle-edit
                  </v-icon>
                  <v-icon class="mx-1" small v-if="item.clean.late == true">
                    mdi-clock
                  </v-icon>
                </v-chip>
              </div>
            </td>
            <td>
              <div class="text-center">
                <v-chip
                  @click="clickOpenDialog(item.check.jobId)"
                  v-if="item.check"
                  :color="getColor(item.check.jobSize)"
                  dark
                  >{{ item.check.licenseNo }}
                  <v-icon class="mx-1" color="red" small v-if="item.check.carPresent == false">
                    mdi-cancel
                  </v-icon>
                  <v-icon small  v-if="item.check.revise == true">
                    mdi-puzzle-edit
                  </v-icon>
                  <v-icon class="mx-1" small v-if="item.check.late == true">
                    mdi-clock
                  </v-icon>
                  </v-chip>
              </div>
            </td>
            <td width="9%" class="yellow-custom-2">
              <div class="text-center">
                <v-chip
                  @click="clickOpenDialog(item.delivery.jobId)"
                  :color="getColor(item.delivery.jobSize)"
                  v-if="item.delivery"
                  dark
                  >{{ item.delivery.licenseNo }}
                  <v-icon class="mx-1" color="red" small v-if="item.delivery.carPresent == false">
                    mdi-cancel
                  </v-icon>
                  <v-icon small  v-if="item.delivery.revise == true">
                    mdi-puzzle-edit
                  </v-icon>
                  <v-icon class="mx-1" small v-if="item.delivery.late == true">
                    mdi-clock
                  </v-icon>
                  </v-chip>
              </div>
            </td>
            <td width="9%" class="green-custom-2">
              <div class="text-center">
                <v-chip
                  @click="clickOpenDialog(item.deliveried.jobId)"
                  :color="getColor(item.deliveried.jobSize)"
                  v-if="item.deliveried"
                  dark
                  >{{ item.deliveried.licenseNo }}
                  <v-icon class="mx-1" color="red" small v-if="item.deliveried.carPresent == false">
                    mdi-cancel
                  </v-icon>
                  <v-icon small  v-if="item.deliveried.revise == true">
                    mdi-puzzle-edit
                  </v-icon>
                  <v-icon class="mx-1" small v-if="item.deliveried.late == true">
                    mdi-clock
                  </v-icon>
                  </v-chip>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td :colspan="12" style="text-align: center">
              No Results Here!
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <v-data-table :items="tableWait" hide-default-header :items-per-page="5">
      <template v-slot:header>
        <thead>
          <tr>
            <th rowspan="2" width="9%"></th>
            <th colspan="10" class="text-center light-red1-custom">
              <h3>งานที่รอขึ้นซ่อม</h3>
            </th>
            <th rowspan="2" width="9%"></th>
          </tr>
          <tr class="grey lighten-2">
            <th class="light-red1-custom">
              <h3 class="text-center">หยุดสถานะ <br />({{ countPause }})</h3>
            </th>
            <th>
              <h3 class="text-center">
                รอประกันอนุมัติ <br />({{ countWaitInsurance }})
              </h3>
            </th>
            <th>
              <h3 class="text-center">รอซ่อม <br />({{ countWaitService }})</h3>
            </th>
            <th>
              <h3 class="text-center">
                รอเตรียมพื้น <br />({{ countPrepareGroundWait }})
              </h3>
            </th>
            <th>
              <h3 class="text-center">รอผสมสี <br />({{ countMixColorWait }})</h3>
            </th>
            <th>
              <h3 class="text-center">
                รอพ่นสี <br />({{ countSprayPaintWait }})
              </h3>
            </th>
            <th>
              <h3 class="text-center">
                รอประกอบ <br />({{ countAssembleWait }})
              </h3>
            </th>
            <th>
              <h3 class="text-center">ขัดสี <br />({{ countWaxWait }})</h3>
            </th>
            <th>
              <h3 class="text-center">
                รอล้าง/เก็บงาน <br />
                ({{ countCleanWait }})
              </h3>
            </th>
            <th>
              <h3 class="text-center">รอตรวจสอบ <br />({{ countCheckWait }})</h3>
            </th>
          </tr>
        </thead>
      </template>
      <template v-slot:body="{ items }">
        <tbody name="list" v-if="items.length > 0">
          <tr v-for="item in items" :key="item.jobId" class="item-row">
            <td width="9%" class="white"></td>

            <td>
              <div class="text-center">
                <v-chip
                  @click="clickOpenDialog(item.pause.jobId)"
                  v-if="item.pause"
                  :color="getColor(item.pause.jobSize)"
                  dark
                  >{{ item.pause.licenseNo }}
                  <v-icon class="mx-1" color="red" small v-if="item.pause.carPresent == false">
                    mdi-cancel
                  </v-icon>
                  <v-icon small  v-if="item.pause.revise == true">
                    mdi-puzzle-edit
                  </v-icon>
                </v-chip>
              </div>
            </td>
            <td>
              <div class="text-center">
                <v-chip
                  @click="clickOpenDialog(item.waitingInsurance.jobId)"
                  v-if="item.waitingInsurance"
                  :color="getColor(item.waitingInsurance.jobSize)"
                  dark
                  >{{ item.waitingInsurance.licenseNo }}
                  <v-icon class="mx-1"
                    color="red" small
                    v-if="item.waitingInsurance.carPresent == false"
                  >
                    mdi-cancel
                  </v-icon>
                  <v-icon small  v-if="item.waitingInsurance.revise == true">
                    mdi-puzzle-edit
                  </v-icon>
                </v-chip>
              </div>
            </td>
            <td>
              <div class="text-center">
                <v-chip
                  @click="clickOpenDialog(item.waitingService.jobId)"
                  v-if="item.waitingService"
                  :color="getColor(item.waitingService.jobSize)"
                  dark
                  >{{ item.waitingService.licenseNo }}
                  <v-icon class="mx-1"
                    color="red" small
                    v-if="item.waitingService.carPresent == false"
                  >
                    mdi-cancel
                  </v-icon>
                  <v-icon small  v-if="item.waitingService.revise == true">
                    mdi-puzzle-edit
                  </v-icon>
                </v-chip>
              </div>
            </td>
            <td>
              <div class="text-center">
                <v-chip
                  @click="clickOpenDialog(item.prepareGround.jobId)"
                  v-if="item.prepareGround"
                  :color="getColor(item.prepareGround.jobSize)"
                  dark
                  >{{ item.prepareGround.licenseNo }}
                  <v-icon class="mx-1"
                    color="red" small
                    v-if="item.prepareGround.carPresent == false"
                  >
                    mdi-cancel
                  </v-icon>
                  <v-icon small  v-if="item.prepareGround.revise == true">
                    mdi-puzzle-edit
                  </v-icon>
                </v-chip>
              </div>
            </td>
            <td>
              <div class="text-center">
                <v-chip
                  @click="clickOpenDialog(item.mixColor.jobId)"
                  v-if="item.mixColor"
                  :color="getColor(item.mixColor.jobSize)"
                  dark
                  >{{ item.mixColor.licenseNo }}
                  <v-icon class="mx-1" color="red" small v-if="item.mixColor.carPresent == false">
                    mdi-cancel
                  </v-icon>
                  <v-icon small  v-if="item.mixColor.revise == true">
                    mdi-puzzle-edit
                  </v-icon>
                </v-chip>
              </div>
            </td>
            <td>
              <div class="text-center">
                <v-chip
                  @click="clickOpenDialog(item.sprayPaint.jobId)"
                  v-if="item.sprayPaint"
                  :color="getColor(item.sprayPaint.jobSize)"
                  dark
                  >{{ item.sprayPaint.licenseNo }}
                  <v-icon class="mx-1" color="red" small v-if="item.sprayPaint.carPresent == false">
                    mdi-cancel
                  </v-icon>
                  <v-icon small  v-if="item.sprayPaint.revise == true">
                    mdi-puzzle-edit
                  </v-icon>
                </v-chip>
              </div>
            </td>
            <td>
              <div class="text-center">
                <v-chip
                  @click="clickOpenDialog(item.assemble.jobId)"
                  v-if="item.assemble"
                  :color="getColor(item.assemble.jobSize)"
                  dark
                  >{{ item.assemble.licenseNo }}
                  <v-icon class="mx-1" color="red" small v-if="item.assemble.carPresent == false">
                    mdi-cancel
                  </v-icon>
                  <v-icon small  v-if="item.assemble.revise == true">
                    mdi-puzzle-edit
                  </v-icon>
                </v-chip>
              </div>
            </td>
            <td>
              <div class="text-center">
                <v-chip
                  @click="clickOpenDialog(item.wax.jobId)"
                  v-if="item.wax"
                  :color="getColor(item.wax.jobSize)"
                  dark
                  >{{ item.wax.licenseNo }}
                  <v-icon class="mx-1" color="red" small v-if="item.wax.carPresent == false">
                    mdi-cancel
                  </v-icon>
                  <v-icon small  v-if="item.wax.revise == true">
                    mdi-puzzle-edit
                  </v-icon>
                </v-chip>
              </div>
            </td>
            <td>
              <div class="text-center">
                <v-chip
                  @click="clickOpenDialog(item.clean.jobId)"
                  v-if="item.clean"
                  :color="getColor(item.clean.jobSize)"
                  dark
                  >{{ item.clean.licenseNo }}
                  <v-icon class="mx-1" color="red" small v-if="item.clean.carPresent == false">
                    mdi-cancel
                  </v-icon>
                  <v-icon small  v-if="item.clean.revise == true">
                    mdi-puzzle-edit
                  </v-icon>
                </v-chip>
              </div>
            </td>
            <td>
              <div class="text-center">
                <v-chip
                  @click="clickOpenDialog(item.check.jobId)"
                  v-if="item.check"
                  :color="getColor(item.check.jobSize)"
                  dark
                  >{{ item.check.licenseNo }}
                  <v-icon class="mx-1" color="red" small v-if="item.check.carPresent == false">
                    mdi-cancel
                  </v-icon>
                  <v-icon small  v-if="item.check.revise == true">
                    mdi-puzzle-edit
                  </v-icon>
                </v-chip>
              </div>
            </td>
            <td width="9%" class="white"></td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td :colspan="12" style="text-align: center">
              No Results Here!
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>

    <DialogCarDetail
      :jobId="jobId"
      :openDialog="openDialog"
      ref="jobDetail"
      :branchCode="branchCode"
      @closeDialog="close"
    ></DialogCarDetail>
  </v-container>
</template>

<script>
import { getControllerBoardById } from '@/api/job/job-api.js';
import DialogCarDetail from './DialogCarDetail';

export default {
  name: 'ListControllerBoard',
  components: {
    DialogCarDetail,
  },
  props: ['branchCode'],
  computed: {
    countAppoint() {
      return this.tableTodo.filter((o) => o.appoint != null).length;
    },
    countPostpone() {
      return this.tableTodo.filter((o) => o.postpone != null).length;
    },
    countWaitingParts() {
      return this.tableTodo.filter((o) => o.waitingParts != null).length;
    },
    countKnock() {
      return this.tableTodo.filter((o) => o.knock != null).length;
    },
    countPrepareGround() {
      return this.tableTodo.filter((o) => o.prepareGround != null).length;
    },
    countMixColor() {
      return this.tableTodo.filter((o) => o.mixColor != null).length;
    },
    countSprayPaint() {
      return this.tableTodo.filter((o) => o.sprayPaint != null).length;
    },
    countAssemble() {
      return this.tableTodo.filter((o) => o.assemble != null).length;
    },
    countWax() {
      return this.tableTodo.filter((o) => o.wax != null).length;
    },
    countClean() {
      return this.tableTodo.filter((o) => o.clean != null).length;
    },
    countCheck() {
      return this.tableTodo.filter((o) => o.check != null).length;
    },
    countDelivery() {
      return this.tableTodo.filter((o) => o.delivery != null).length;
    },
    countDeliveried() {
      return this.tableTodo.filter((o) => o.deliveried != null).length;
    },
    countPause() {
      return this.tableWait.filter((o) => o.pause != null).length;
    },
    countWaitInsurance() {
      return this.tableWait.filter((o) => o.waitingInsurance != null).length;
    },
    countWaitService() {
      return this.tableWait.filter((o) => o.waitingService != null).length;
    },
    countPrepareGroundWait() {
      return this.tableWait.filter((o) => o.prepareGround != null).length;
    },
    countMixColorWait() {
      return this.tableWait.filter((o) => o.mixColor != null).length;
    },
    countSprayPaintWait() {
      return this.tableWait.filter((o) => o.sprayPaint != null).length;
    },
    countAssembleWait() {
      return this.tableWait.filter((o) => o.assemble != null).length;
    },
    countWaxWait() {
      return this.tableWait.filter((o) => o.wax != null).length;
    },
    countCleanWait() {
      return this.tableWait.filter((o) => o.clean != null).length;
    },
    countCheckWait() {
      return this.tableWait.filter((o) => o.check != null).length;
    },
    sum() {
      return {};
    },
    countStatusCar() {
      return {};
    },
    countStatusCarWait() {
      return {};
    },
  },
  data: () => ({
    jobId: null,
    jobDetail: null,
    openDialog: false,
    date: null,
    isError: false,
    tableTodo: [],
    tableWait: [],
    header: {},
  }),
  methods: {
    setTableOnProcess(data) {
      this.tableTodo = data;
    },
    setTableWait(data) {
      this.tableWait = data;
    },
    setHeader(header) {
      this.header = header;
    },
    setTable(data) {
      if (data.length > 0) {
        this.tableTodo = data.filter((data) => data.waitingJobStatus !== true);
        this.tableWait = data.filter(
          (data) =>
            data.waitingJobStatus !== false ||
            data.waitInsurance !== false ||
            data.jobStatusCode == 0 ||
            data.jobStatusCode == 1
        );
      } else {
        this.tableTodo = [];
        this.tableWait = [];
      }
    },
    close() {
      this.openDialog = false;
      this.jobDetail = null;
    },
    clickOpenDialog(id) {
      this.jobId = id;
      this.$loading(true);
      getControllerBoardById(this.jobId)
        .then((rs) => {
          this.$refs.jobDetail.setJobDetail(rs);
          this.$loading(false);
          this.openDialog = true;
        })
        .catch((e) => {
          alert(e);
          this.$loading(false);
        });
    },
    getColor(value) {
      if (value === 'L') return '#ff8c00';
      else if (value === 'M') return 'green';
      else if (value === 'H') return 'red';
      else return 'White';
    },
    addClick() {
      this.$emit('addClick');
    },
  },
};
</script>

<style scoped>
.v-application .light-blue1-custom {
  background-color: #0b4485 !important;
  height: 70px;
}
.v-application .light-blue2-custom {
  background-color: #1b80b2 !important;
}
.v-application .yellow-custom {
  background-color: #ffb819 !important;
  border-color: #ff0 !important;
}
.v-application .yellow-custom-2 {
  background-color: #fff9c4 !important;
  border-color: #fff9c4 !important;
}
.v-application .green-custom {
  background-color: #4ee182 !important;
  border-color: #76ff03 !important;
}
.v-application .green-custom-2 {
  background-color: #ccff90 !important;
  border-color: #ccff90 !important;
}
.v-application .light-red1-custom {
  background-color: #ff9999 !important;
}
.v-application .border-custom {
  border: thin solid rgb(255 255 255 / 79%);
  color: white;
}
</style>
